export const APP_VERSION = '8.2.1-1'
